interface InfoIconProps extends React.SVGProps<SVGSVGElement> {
  /**
   * Accessible name and hover tooltip. This icon is informative, not decorative,
   * so it carries a label (role="img" + <title>) rather than aria-hidden.
   */
  label: string;
}

export default function InfoIcon({ label, ...props }: InfoIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      role="img"
      aria-label={label}
      {...props}
    >
      <title>{label}</title>
      <circle cx="12" cy="12" r="9" />
      <line x1="12" y1="11" x2="12" y2="16" />
      <line x1="12" y1="8" x2="12" y2="8" />
    </svg>
  );
}
